/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Mesh } from 'three';
import { ObjectSelector } from '../../ObjectSelector';
const purgeTransformMatrix = (mesh) => {
    mesh.updateMatrix();
    const tmp = mesh.geometry.clone();
    tmp.applyMatrix(mesh.matrix);
    mesh.geometry = tmp;
    mesh.position.set(0, 0, 0);
    mesh.rotation.set(0, 0, 0);
    mesh.scale.set(1, 1, 1);
    return mesh;
};
export const createMesh = (name, geometry, material, transform) => {
    const mesh = new Mesh(geometry, material);
    mesh.name = name;
    mesh.userData[ObjectSelector.UNTOUCHABLE] = true;
    mesh.userData[ObjectSelector.INTERACTION_PRIORITY] = 1000;
    if (transform) {
        const { position, rotation, scale } = transform;
        if (position) {
            mesh.position.copy(position);
        }
        if (rotation) {
            mesh.rotation.copy(rotation);
        }
        if (scale) {
            mesh.scale.copy(scale);
        }
        purgeTransformMatrix(mesh);
    }
    return mesh;
};
//# sourceMappingURL=createMesh.js.map